import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, inject } from '@angular/core';
import { MembershipPluginsService } from '@common/membership/shared';
import { UiIconsModule } from '@common/ui/frontend-shared/icons';
import { UiSpinnerComponent } from '@common/ui/frontend-shared/spinner';
import { CoreFrontendSharedModule, PageFacade, takeWhileAlive } from '@core/frontend-shared';
import { Store } from '@ngxs/store';
import { Angulartics2 } from 'angulartics2';
import { combineLatest, map } from 'rxjs';
import { MembershipRegistrationFacade, MembershipRegistrationState } from '../state';
import * as i0 from "@angular/core";
import * as i1 from "../state";
import * as i2 from "@ngxs/store";
import * as i3 from "@common/membership/shared";
import * as i4 from "angulartics2";
import * as i5 from "@core/frontend-shared";
import * as i6 from "../../../../../../core/frontend-shared/src/lib/dynamic-components/dynamic-component.directive";
import * as i7 from "@angular/common";
function RegistrationFormsComponent_Conditional_0_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function RegistrationFormsComponent_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, RegistrationFormsComponent_Conditional_0_ng_container_0_Template, 1, 0, "ng-container", 1);
  }
  if (rf & 2) {
    i0.ɵɵproperty("dynamicComponent", ctx);
  }
}
function RegistrationFormsComponent_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "ui-spinner", 0);
  }
}
/**
 * This component displays all forms that are required to start a membership.
 */
export let RegistrationFormsComponent = /*#__PURE__*/(() => {
  class RegistrationFormsComponent {
    constructor(registration, store, pluginsService, cd, angulartics2, page) {
      this.registration = registration;
      this.store = store;
      this.pluginsService = pluginsService;
      this.cd = cd;
      this.angulartics2 = angulartics2;
      this.page = page;
      this.displayMode$ = inject(Store).select(MembershipRegistrationState.displayMode);
      this.formData$ = inject(Store).select(MembershipRegistrationState.allFormData);
      this.pluginFormState$ = inject(Store).select(MembershipRegistrationState.pluginFormState);
      this.requireAccountData$ = inject(Store).select(MembershipRegistrationState.requireAccountData);
      this.enabledSummaryStep$ = inject(Store).select(MembershipRegistrationState.enabledSummaryStep);
      this.membershipType$ = inject(Store).select(MembershipRegistrationState.membershipType);
      this.activePlugin$ = this.membershipType$.pipe(map(type => {
        if (!type) return null;
        return this.pluginsService.getPluginInstance(type);
      }));
      this.componentWithParams$ = combineLatest({
        plugin: this.activePlugin$,
        formData: this.formData$,
        state: this.pluginFormState$,
        displayMode: this.displayMode$,
        requireAccountData: this.requireAccountData$,
        submitsImmediately: this.enabledSummaryStep$.pipe(map(enableSummary => !enableSummary))
      }).pipe(map(data => {
        if (!data.plugin) return null;
        const component = data.plugin.getRegistrationComponent();
        return {
          inputs: {
            ...data,
            platform: 'frontend'
          },
          outputs: {
            onComplete: this.pluginFormCompleted,
            onSaveFormState: this.onSaveFormState
          },
          component
        };
      }));
      this.pluginTitle$ = this.activePlugin$.pipe(map(plugin => {
        const info = plugin?.getStaticPluginInfo() || {};
        return info.description || info.name || 'Jetzt registrieren';
      }));
      this.pluginFormCompleted = formData => {
        this.angulartics2.eventTrack.next({
          action: 'forms-submit',
          properties: {
            category: 'membership-registration'
          }
        });
        this.registration.setFormData(formData);
        this.registration.confirmStep();
      };
      this.onSaveFormState = pluginFormStateInfo => {
        this.registration.setPluginFormState(pluginFormStateInfo);
      };
      this.pluginTitle$.pipe(takeWhileAlive()).subscribe(title => {
        this.page.setTitle(title);
      });
    }
    ngAfterViewInit() {
      this.angulartics2.eventTrack.next({
        action: 'forms-start',
        properties: {
          category: 'membership-registration'
        }
      });
    }
    static {
      this.ɵfac = function RegistrationFormsComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || RegistrationFormsComponent)(i0.ɵɵdirectiveInject(i1.MembershipRegistrationFacade), i0.ɵɵdirectiveInject(i2.Store), i0.ɵɵdirectiveInject(i3.MembershipPluginsService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i4.Angulartics2), i0.ɵɵdirectiveInject(i5.PageFacade));
      };
    }
    static {
      this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
        type: RegistrationFormsComponent,
        selectors: [["membership-registration-forms"]],
        decls: 3,
        vars: 3,
        consts: [["label", "Lade Registrierung..."], [4, "dynamicComponent"]],
        template: function RegistrationFormsComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵconditionalCreate(0, RegistrationFormsComponent_Conditional_0_Template, 1, 1, "ng-container");
            i0.ɵɵpipe(1, "async");
            i0.ɵɵconditionalBranchCreate(2, RegistrationFormsComponent_Conditional_2_Template, 1, 0, "ui-spinner", 0);
          }
          if (rf & 2) {
            let tmp_0_0;
            i0.ɵɵconditional((tmp_0_0 = i0.ɵɵpipeBind1(1, 1, ctx.componentWithParams$)) ? 0 : 2, tmp_0_0);
          }
        },
        dependencies: [CommonModule, CoreFrontendSharedModule, i6.DynamicComponentDirective, UiSpinnerComponent, UiIconsModule, i7.AsyncPipe],
        styles: [".bottom-bar[_ngcontent-%COMP%]{display:flex;justify-content:center;--inputBorderRadius:20px}.steps[_ngcontent-%COMP%]{padding:0;margin:40px 0 0}@media (max-width: 767px){.steps[_ngcontent-%COMP%]{display:none}}@media (min-width: 768px){.steps[_ngcontent-%COMP%]{list-style:none;display:flex;justify-content:center;align-items:center}.steps[_ngcontent-%COMP%]   .step[_ngcontent-%COMP%]{text-align:center;position:relative}.steps[_ngcontent-%COMP%]   .step[_ngcontent-%COMP%]{background:var(--contentSoftColor);border:2px solid var(--contentSoftColor);padding:12px;border-radius:15px}.steps[_ngcontent-%COMP%]   .step.completed[_ngcontent-%COMP%]{color:var(--disabledTextColor)}.steps[_ngcontent-%COMP%]   .step.current[_ngcontent-%COMP%]{color:var(--primaryColor);border-color:var(--primaryColor)}.steps[_ngcontent-%COMP%]   .step[_ngcontent-%COMP%] > ui-icon[_ngcontent-%COMP%]{position:absolute;right:10px;top:10px;color:var(--primaryColor)}.steps[_ngcontent-%COMP%]   .number[_ngcontent-%COMP%]{font-weight:700;font-size:30px}.steps[_ngcontent-%COMP%]   .spacer[_ngcontent-%COMP%]{margin:0 10px;height:2px;display:block;background:var(--disabledTextColor);position:relative;flex:1;opacity:.5;max-width:30%}.steps[_ngcontent-%COMP%]   .spacer[_ngcontent-%COMP%]   svg[_ngcontent-%COMP%]{width:20px;position:absolute;right:-2px;top:-9px;fill:currentColor}}@media (min-width: 960px){.steps[_ngcontent-%COMP%]   .step[_ngcontent-%COMP%]{padding:20px;border-radius:20px}.steps[_ngcontent-%COMP%]   .number[_ngcontent-%COMP%]{font-size:40px}.steps[_ngcontent-%COMP%]   .spacer[_ngcontent-%COMP%]{margin:0 20px}}.forms[_ngcontent-%COMP%]{margin:50px 0 30px}"],
        changeDetection: 0
      });
    }
  }
  return RegistrationFormsComponent;
})();